export default __webpack_public_path__ + "static/media/auth-box-loadbar.12c1d913.gif";